import { useForm } from '@inertiajs/react'
import AuthLayout from '@/layouts/AuthLayout'
import type { FormEvent } from 'react'

export default function ForgotPassword() {
  const { data, setData, post, processing } = useForm({
    email_address: '',
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/forgot_password')
  }

  return (
    <AuthLayout title="Reset your password">
      <div className="card bg-base-100 shadow-lg">
        <div className="card-body">
          <h2 className="card-title text-2xl font-bold mb-2">Forgot your password?</h2>
          <p className="text-sm text-base-content/60 mb-4">
            Enter the email address you signed up with and we'll send you a link to reset your password.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <fieldset className="fieldset">
              <legend className="fieldset-legend">Email</legend>
              <input
                type="email"
                className="input w-full"
                value={data.email_address}
                onChange={(e) => setData('email_address', e.target.value)}
                required
                autoFocus
                autoComplete="email"
              />
            </fieldset>

            <button
              type="submit"
              className="btn btn-primary w-full"
              disabled={processing}
            >
              {processing && <span className="loading loading-spinner loading-sm" />}
              Send reset link
            </button>
          </form>

          <p className="text-sm text-center mt-4">
            Remembered it?{' '}
            <a href="/login" className="link link-primary">
              Back to log in
            </a>
          </p>
        </div>
      </div>
    </AuthLayout>
  )
}
